var map = {
	"./old-paynlsofort-grey.svg": 7271,
	"./old-paynlsofort.svg": 7593,
	"./paynlamex.svg": 7393,
	"./paynlapplepay.svg": 4238,
	"./paynlbancontact.svg": 6385,
	"./paynlfestivalcadeau.svg": 8055,
	"./paynlgiropay-grey.svg": 1975,
	"./paynlgiropay.svg": 4345,
	"./paynlgooglepay.svg": 593,
	"./paynlideal-grey.svg": 933,
	"./paynlideal.svg": 3251,
	"./paynlmaestro.svg": 3395,
	"./paynlpayconic.svg": 6294,
	"./paynlpaypal.svg": 785,
	"./paynlsofort-grey.svg": 3151,
	"./paynlsofort.svg": 8273,
	"./paynlstc-grey.svg": 4944,
	"./paynlstc.svg": 8896,
	"./paynlvisa.svg": 8971
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9264;